import {
	Card,
	CardHeader,
	CardFooter,
	Table,
	Container,
	Row,
	BreadcrumbItem,
	Breadcrumb,
	Input,
} from "reactstrap"
// core components
import { Component } from "react"
import { Link } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { connect } from "react-redux"
import { sacrament } from "../../../redux/actions"

class Baptism extends Component {
	constructor(props) {
		super(props)

		this.state = {
			params: {
				limit: 10,
				page: 1,
			},
		}
	}

	handlePageClick(e) {
		const oldState = { ...this.state }

		oldState.params.page = e.selected + 1

		this.setState(oldState, () => {
			this.getBaptisms()
		})
	}

	getBaptisms() {
		this.props.getBaptisms(this.state.params)
	}

	componentDidMount() {
		this.getBaptisms()
	}

	render() {
		return (
			<>
				{/* Page content */}
				<Container fluid className='mb-5'>
					<div>
						<Breadcrumb>
							<BreadcrumbItem>
								<Link to='/admin/sacrament'>Sakramen</Link>
							</BreadcrumbItem>
							<BreadcrumbItem active>Baptisan</BreadcrumbItem>
						</Breadcrumb>
					</div>
					{/* Table */}
					<Row>
						<div className='col'>
							<Card>
								<CardHeader className='d-flex'>
									<h3 className='mr-auto'>Baptisan</h3>
								</CardHeader>
								<CardHeader>
									<div className='row'>
										<div className='has-search col-xl-4'>
											<span className='fa fa-search form-control-feedback'></span>
											<Input
												type='text'
												className='form-control'
												placeholder='Cari berdasarkan nama'
												onKeyDown={(e) => {
													if (e.key === "Enter") {
														this.getBaptisms()
													}
												}}
												onChange={(e) => {
													this.setState({
														params: Object.assign({}, this.state.params, {
															search: e.target.value,
														}),
													})
												}}
											/>
										</div>
									</div>
								</CardHeader>
								<Table
									className='align-items-center table-flush table-striped'
									responsive
								>
									<thead className='thead-light'>
										<tr>
											<th scope='col'>No.</th>
											<th scope='col'>Nama</th>
											<th scope='col'>Tempat Lahir</th>
											<th scope='col'>Tanggal Lahir</th>
											<th scope='col'>Action</th>
										</tr>
									</thead>
									<tbody>
										{this.props.baptism.data.map((baptism, i) => (
											<tr>
												<td>
													{(this.props.baptism.page.currentPage - 1) *
														this.state.params.limit +
														i +
														1}
												</td>
												<td>{baptism.name}</td>
												<td>{baptism.birthplace}</td>
												<td>{baptism.birthdate}</td>
												<td>
													<Link
														to={{
															pathname: `/admin/sacrament/baptism/${baptism.id}`,
														}}
													>
														Lihat Detail
													</Link>
												</td>
											</tr>
										))}
									</tbody>
								</Table>
								<CardFooter className='py-4 d-flex justify-content-end align-items-center'>
									<p>
										{`Menampilkan ${this.props.baptism.data.length} dari ${this.props.baptism.page.totalData} data`}
									</p>
									<ReactPaginate
										breakLabel='...'
										nextLabel='&raquo;'
										onPageChange={this.handlePageClick.bind(this)}
										pageRangeDisplayed={1}
										pageCount={this.props.baptism.page.totalPage}
										marginPagesDisplayed={1}
										previousLabel='&laquo;'
										renderOnZeroPageCount={null}
										className='pagination ml-3'
										pageClassName='page-item'
										pageLinkClassName='page-link'
										activeClassName='active'
										disabledClassName='disabled'
										nextClassName='page-item'
										breakClassName='page-item'
										nextLinkClassName='page-link'
										previousClassName='page-item'
										previousLinkClassName='page-link'
										breakLinkClassName='page-link'
									/>
								</CardFooter>
							</Card>
						</div>
					</Row>
				</Container>
			</>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		baptism: state.baptism,
	}
}

const mapDispatchToProps = {
	getBaptisms: sacrament.getBaptisms,
}

export default connect(mapStateToProps, mapDispatchToProps)(Baptism)
